import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { TranslateService } from "@ngx-translate/core";
import { BreadCrumbModel } from "app/views/campaign-3/models/campaign-3-breadcrumb.model";
import { DistributionList3, DistributionListDetails } from "app/views/campaign-3/models/campaign-3.model";
import { DistributionList3Service } from "../services/distribution3.service";

@Component({
  selector: 'app-edit-create-distribution-list-3',
  templateUrl: './edit-create-distribution-list-3.component.html',
  styleUrls: ['./edit-create-distribution-list-3.component.css']
})
export class EditCreateDistributionList3Component implements OnInit {

  breadcrumbs: Array<BreadCrumbModel> = [];
  distributionListDetail: DistributionList3;

  @ViewChild('distributionList_name') distributionListName;
  @ViewChild('previewList') previewList;
  @ViewChild('distributionList_description') distributionListDescription;

  fieldModel = {
    name: '',
    description: '',
    previewList: false
  }
  idDistributionListEdit;
  readOnly: boolean = false;
  editMode: boolean = false;

  constructor(
    public router: Router,
    private translate: TranslateService,

    private distributionService: DistributionList3Service
  ) { }

  ngOnInit(): void {
    this.initBreadCrumbs();
    this.loadDistributionListDetails();
  }

  private initBreadCrumbs(): void {
    const breadcrumb = new BreadCrumbModel();
    breadcrumb.code = "bc1";
    breadcrumb.description = "Lista di Distribuzione";
    breadcrumb.routerLink = "/distribution-list-3";
    this.breadcrumbs.push(breadcrumb);
    const breadcrumb2 = new BreadCrumbModel();
    breadcrumb2.code = "bc2";
    breadcrumb2.description = "Creazione/Modifica";
    breadcrumb2.routerLink = "/edit-create-distribution-list-3";
    this.breadcrumbs.push(breadcrumb2);
  }

  private loadDistributionListDetails(): void {
    this.distributionListDetail = this.distributionService.getData();
    if (this.distributionListDetail) {
      this.fieldModel.name = this.distributionListDetail.distributionListName || '';
      this.fieldModel.description = this.distributionListDetail.distributionListDescription || '';
      this.fieldModel.previewList = this.distributionListDetail.flgPreview === '1';

      this.idDistributionListEdit = this.distributionListDetail.distributionListId

      console.log(this.distributionListDetail);
      this.editMode = true;
    } else {
      this.editMode = false;

      console.warn('Dati non trovati!');
    }
  }

  breadcrumbClicked(breadcrumb: BreadCrumbModel): void {
    if (breadcrumb.routerLink) {
      this.router.navigate([breadcrumb.routerLink]);
    } else {
      console.log("Nessuna route implementata");
    }
  }

  onBackAction(): void {
    this.router.navigate(['/distribution-list-3']);
  }

  onSaveDistributionList(): void {
    this.performNewDistributionValidation();
  }
  performNewDistributionValidation(): void {
    // Array di tutti i campi da validare
    const fields = [
      this.distributionListName,
      this.distributionListDescription,
      this.previewList,
    ];

    let allValid = true;

    // Validazione di ogni campo
    fields.forEach((field) => {
      field.performValidation();
      if (!field.valid) {
        allValid = false; // Se almeno un campo non è valido
        console.error(`Errore nel campo: ${field.errorMessage}`);
      }
    });
    // Se tutto è valido, procedi al salvataggio
    if (allValid) {
      console.log("Tutti i campi sono validi. Salvataggio in corso...");
      const payload = {
        name: this.fieldModel.name,
        description: this.fieldModel.description,
        flg_preview_list: this.fieldModel.previewList ? 1 : 0,
      };

      //se sono in edit modifico altrimenti salviamo
      if (this.editMode) {
        this.distributionService.editDistributionList(payload, this.idDistributionListEdit).subscribe(
          res => {
            console.log(res);
            if (res) {
              this.goToDistributionList()
            }
          }
        )
      } else {
        this.distributionService.saveNewDistributionList(payload).subscribe(
          res => {
            console.log(res);
            if (res) {
              this.goToDistributionList()
            }
          })
      }
    } else {
      console.error("Errore nella validazione. Verifica i campi evidenziati.");
    }
  }



  goToDistributionList() {
    this.router.navigate(["/distribution-list-3"])
  }

}



// WEBPACK FOOTER //
// ./src/app/views/distribution-list/edit-create-distribution-list-3/edit-create-distribution-list-3.component.ts